import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4ed540a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TumiBackLogin" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"TumiLogin\" data-v-4ed540a6><div class=\"TumiForm\" data-v-4ed540a6><div data-v-4ed540a6><img src=\"" + _imports_0 + "\" alt=\"LogoTumi\" class=\"TumiLogoLola\" data-v-4ed540a6><div class=\"mt-4\" data-v-4ed540a6><p class=\"TumiTextLight mb-4 text-white\" data-v-4ed540a6>The key has been objected. This will be confirmed by mail to all the parties.</p></div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}